module.exports = __webpack_public_path__ + "components/outside-promo-page/static/apple-4692e52d4eaedc2b2513a5deaf3a251c.png";